@let currUser = user();
@let tabId = activeTabId();

<div class="flex h-full flex-col items-stretch overflow-hidden bg-linear-to-br from-neutral-50 to-primary-50/50">
  @defer (when currUser; prefetch on idle) {
    <ks-topbar [user]="currUser" />
    <div class="relative flex min-h-0 flex-auto items-stretch">
      <ks-sidebar
        [menuExpanded]="currUser?.preferences?.menuExpanded ?? true"
        [companyLogoUrl]="currUser?.company?.logoUrl ?? null"
        (menuToggled)="toggleMenu()"
      />
      <main class="mr-3 mb-3 flex min-h-0 min-w-0 flex-auto flex-col rounded-md border border-neutral-200 bg-white">
        <ks-tabbar />
        <div
          id="ks-tab-panel"
          role="tabpanel"
          class="min-h-0 flex-auto"
          [attr.aria-labelledby]="tabId ? 'ks-tab-' + tabId : null"
          [class.p-3]="padded()"
        >
          <router-outlet />
        </div>
      </main>
    </div>
  } @loading (minimum 500ms) {
    <div
      class="flex flex-auto items-center justify-center bg-white"
      aria-busy="true"
      aria-live="polite"
    >
      {{ 'common.loading' | ksTranslate }}
    </div>
  }
</div>
